import { Directive, ComponentRef, AfterViewInit, ComponentFactoryResolver, ViewContainerRef } from '@angular/core';
import { TargetAppService } from '../services/parameter';
import { IApplication } from '../interfaces';
import { distinctUntilChanged } from 'rxjs/operators';
import { ComponentProviderService } from '../services/component-provider.service';

/**
 * Directive base for make a change visual for element component
 *
 * The component that uses the directive should provide a ``provider`` service
 */
@Directive({
  selector: '[appComponentProvider]'
})
export class ComponentProviderDirective implements AfterViewInit {

  protected componentRef: ComponentRef<any>;

  constructor(
    protected app: TargetAppService,
    protected provider: ComponentProviderService,
    protected componentFactoryResolver: ComponentFactoryResolver,
    protected viewContainerRef: ViewContainerRef
  ) { }

  public ngAfterViewInit(): void {
    /**
     * Subscription to app change event
     *
     * Changes only when the selected app is distinct of previous
     */
    this.app.getObservable().pipe(
      distinctUntilChanged((prev, curr) => prev.menuId === curr.menuId),
    ).subscribe(application => this.onAppChange(application));
  }

  /**
   * Changes the layout of application
   * 
   * @param application Current application configuration
   */
  public onAppChange(application: IApplication): void {
    if (application) {
      // TODO Implementar en BD el tipo de layoutType para obtener el tipo de layout
      const applicationType = 'default';
      // const applicationType = application.layoutType;
      const component = this.provider.get(applicationType);
      const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
      this.viewContainerRef.remove();
      this.componentRef = this.viewContainerRef.createComponent(componentFactory);
      this.componentRef.changeDetectorRef.detectChanges();
    }
  }
}
